module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh_cn":{"allContentCategory":"所有内容类别","allPageCategory":"所有专题类别"},"zh_hk":{"allContentCategory":"所有內容類別","allPageCategory":"所有專題類別"},"en":{"allContentCategory":"All content categories","allPageCategory":"All topic categories"},"ja":{"allContentCategory":"すべてのコンテンツ カテゴリ","allPageCategory":"すべてのトピック カテゴリ"}}')
  delete Component.options._Ctor
}
